export const PIM_LOCAL_STORAGE_PREFIX = "pim_ls_";
